module.exports = __webpack_public_path__ + "static/img/建筑智能化_智能安防2@2x.694899a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_智能安防2@2x.png
// module id = PoNz
// module chunks = 1